
import { Project } from "@/types/Project";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ProjectSelectorProps {
  projects: Project[];
  selectedProject: string;
  setSelectedProject: (id: string) => void;
}

export function ProjectSelector({ projects, selectedProject, setSelectedProject }: ProjectSelectorProps) {
  return (
    <Select 
      value={selectedProject} 
      onValueChange={setSelectedProject}
    >
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Select Project" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Projects</SelectItem>
        {projects.map((project) => (
          <SelectItem key={project.id} value={project.id}>
            {project.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
